import { FaMapMarkerAlt, FaPhoneAlt, FaDirections } from "react-icons/fa";
import { LOCATION_LIST } from "../../data/locations";

const photosById = {
  mandsaur: "/images/real/mandsaur-entrance.jpeg",
  neemuch: "/images/real/neemuch-entrance.webp",
};

const Locations = () => {
  return (
    <div className="py-16 px-4 md:px-10 bg-white">
      <div className="text-center mb-12">
        <h5 className="text-primary-dark font-semibold uppercase tracking-widest text-sm mb-2">
          Find Us
        </h5>
        <h1 className="font-display text-4xl font-bold text-gray-800">
          Our Locations
        </h1>
        <p className="text-gray-500 mt-2">
          Now serving guests in two cities
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {LOCATION_LIST.map((loc) => (
          <div
            key={loc.id}
            className="rounded-2xl overflow-hidden shadow-lg bg-cream transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            <img
              src={photosById[loc.id]}
              alt={`Second Home ${loc.name}`}
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="font-display text-2xl font-bold text-gray-800 mb-3">
                {loc.name}
              </h3>
              <p className="text-gray-600 text-sm flex gap-2 mb-3">
                <FaMapMarkerAlt className="text-primary mt-1 shrink-0" />
                <span>{loc.address}</span>
              </p>
              <a
                href={loc.phoneHref}
                className="text-sm flex items-center gap-2 mb-4 text-gray-700 hover:text-primary-dark transition-colors"
              >
                <FaPhoneAlt className="text-primary shrink-0" />
                {loc.phoneDisplay}
              </a>
              <a
                href={loc.directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-ink font-semibold text-sm py-2 px-4 rounded-full transition-colors"
              >
                <FaDirections /> Get Directions
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Locations;
